import {useMemo, useState} from "react";
import {TtaMappedPairEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useDebouncedValue} from "@mantine/hooks";

export type UseTicketDataTableFilterProps = Omit<UseDataTableFilterProps<TtaMappedPairEntity>, 'filterConfig'>

export function useTicketCompareDataTableFilter(props: UseTicketDataTableFilterProps): UseDataTableFilterResult<TtaMappedPairEntity> {
  const {records} = props;

  const [idQuery, setIdQuery] = useState<string | undefined>(undefined);
  const [idDebouncedQuery] = useDebouncedValue(idQuery, 200);

  const [ticketNumberQuery, setTicketNumberQuery] = useState<string | undefined>(undefined);
  const [ticketNumberDebouncedQuery] = useDebouncedValue(idQuery, 200);

  const filterConfig: DataTableFilterConfig<TtaMappedPairEntity> = useMemo(() => {
    return {
      "id": {
        setQuery: setIdQuery,
        query: idQuery,
        debouncedQuery: idDebouncedQuery,
        filter: (record, query) => !record.dbTta || !record.dbTta.resourceIdentifiers.join(",").toLowerCase().includes(query.toLowerCase())
      },
      "ticketNumber": {
        setQuery: setTicketNumberQuery,
        query: ticketNumberQuery,
        debouncedQuery: ticketNumberDebouncedQuery,
        filter: (record, query) =>
          !record.tta || !record.tta.pickupTransport || !record.tta.pickupTransport.ticketNumber || !record.tta.pickupTransport.ticketNumber.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    idDebouncedQuery,
    idQuery,
    ticketNumberDebouncedQuery,
    ticketNumberQuery,
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
